<template>
  <div>
    <a-form-model ref="form" :model="form.data" :rules="form.rules">
      <a-form-model-item
        prop="giid"
        label="商品">
        <img-goods-select-checkbox v-model="form.data.goodsId"  v-on:confirm="getConfirmtarget" :goodsId="form.data.goodsId"/>
      </a-form-model-item>
      <a-form-model-item>
        <a-space>
          <a-button type="primary" v-if="!lookBookGoodsId" @click="onAdd">
            {{ $t('CREATE') || '创建' }}
          </a-button>
          <a-button type="primary" v-if="lookBookGoodsId" @click="onUpdate">
            {{ $t('UPDATE') || '更新' }}
          </a-button>

          <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import {
  _queryLookBookGoods,
  _addLookBookGoodsList,
  _updateLookBookGoodsList,
} from '@/api/lookBookGoodsApi';
import ImgGoodsSelectCheckbox from '@/components/contentSelector/ImgGoodsSelectCheckbox.vue';

async function getLookBookGoods() {
  const result = await _queryLookBookGoods(this.lookBookGoodsId);
  if (result) {
    this.form.data.goodsId = result.goodsId;
  }
}

async function onAdd() {
  console.log(this.form.data.target);
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addLookBookGoodsList({
        goodsIds: this.form.data.target,
        lookBookId: this.lookBookId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateLookBookGoodsList(this.lookBookGoodsId, {
        // goodsId: this.form.data.goodsId,
        goodsIds: this.form.data.target,
        lookBookId: this.lookBookId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'LookBookGoodsEdit',
  components: {
    ImgGoodsSelectCheckbox,
  },
  props: {
    lookBookGoodsId: String,
    lookBookId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    lookBookGoodsId() {
      if (this.lookBookGoodsId) {
        this.getLookBookGoods();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getLookBookGoods,
    getConfirmtarget(data) {
      // console.log(data);
      this.form.data.target = data;
    }
  },
  data() {
    return {
      form: {
        data: {
          goodsId: '',
          target: [],
        },
        rules: {
          goodsId: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.lookBookGoodsId) {
      this.getLookBookGoods();
    }
  },
};
</script>
